import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import { BreadcrumbItem } from '../types'

interface BreadcrumbItemDesktopProps {
  item: BreadcrumbItem
  index: number
  showIcon: boolean
}

export function BreadcrumbItemDesktop({ item, index, showIcon }: BreadcrumbItemDesktopProps) {
  return (
    <NavigationMenu.Item className="flex items-center gap-1">
      {showIcon && (
        <div className="flex items-center gap-1 border-r border-foreground pr-3">
          {item.icon}
        </div>
      )}
      <div className="flex items-center gap-1 min-w-0">
        {index > 0 && (
          <ChevronRight className="w-4 h-4 text-gray-400 flex-shrink-0" />
        )}
        {item.href ? (
          <Link
            to={item.href}
            className="flex items-center gap-1 px-2 text-sm text-gray-600 hover:text-gray-900 transition-colors rounded min-w-0"
          >
            <span className="truncate">{item.label}</span>
          </Link>
        ) : (
          <span className="flex items-center gap-1 px-2 text-sm text-gray-900 font-semibold min-w-0">
            <span className="truncate">{item.label}</span>
          </span>
        )}
      </div>
    </NavigationMenu.Item>
  )
}
